import { useEffect } from 'react';
import './legalmodal.css';

// Close icon
function CloseIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
    );
}

// Content for Privacy Policy
function PrivacyPolicyContent() {
    return (
        <div className="legal-content">
            <h2>Политика конфиденциальности</h2>
            <p className="legal-last-updated">Последнее обновление: {new Date().toLocaleDateString('ru-RU')}</p>
            
            <section>
                <h3>1. Общие положения</h3>
                <p>
                    Настоящая Политика конфиденциальности описывает, как Spiria («мы», «наш» или «нас») 
                    собирает, использует и защищает информацию, которую вы предоставляете при использовании 
                    нашей платформы управления здоровьем.
                </p>
            </section>

            <section>
                <h3>2. Собираемая информация</h3>
                <p>Мы можем собирать следующие типы информации:</p>
                <ul>
                    <li><strong>Персональные данные:</strong> имя, фамилия, email, номер телефона</li>
                    <li><strong>Медицинская информация:</strong> история прохождения опросов, назначенные лекарства</li>
                    <li><strong>Технические данные:</strong> IP-адрес, тип браузера, устройство</li>
                    <li><strong>Данные использования:</strong> статистика посещений, предпочтения</li>
                </ul>
            </section>

            <section>
                <h3>3. Использование информации</h3>
                <p>Мы используем собранную информацию для:</p>
                <ul>
                    <li>Предоставления медицинских услуг и функций платформы</li>
                    <li>Отправки напоминаний о приёме лекарств</li>
                    <li>Улучшения качества обслуживания</li>
                    <li>Обеспечения безопасности аккаунта</li>
                    <li>Связи с вами по вопросам использования сервиса</li>
                </ul>
            </section>

            <section>
                <h3>4. Защита данных</h3>
                <p>
                    Мы принимаем соответствующие меры безопасности для защиты ваших персональных данных 
                    от несанкционированного доступа, изменения, раскрытия или уничтожения. 
                    Все данные передаются по зашифрованному каналу (SSL/TLS).
                </p>
            </section>

            <section>
                <h3>5. Передача данных третьим лицам</h3>
                <p>Мы не продаём и не передаём ваши персональные данные третьим лицам, за исключением:</p>
                <ul>
                    <li>Ваших лечащих врачей, имеющих доступ к платформе</li>
                    <li>Служб технической поддержки (при необходимости)</li>
                    <li>По требованию законодательства РФ</li>
                </ul>
            </section>

            <section>
                <h3>6. Хранение данных</h3>
                <p>
                    Ваши данные хранятся на защищённых серверах, расположенных на территории Российской Федерации. 
                    Мы храним данные в течение времени, необходимого для предоставления услуг, 
                    или до вашего запроса на удаление.
                </p>
            </section>

            <section>
                <h3>7. Ваши права</h3>
                <p>Вы имеете право:</p>
                <ul>
                    <li>Получить доступ к своим персональным данным</li>
                    <li>Исправить неточные данные</li>
                    <li>Удалить свои данные (право «на забвение»)</li>
                    <li>Отозвать согласие на обработку данных</li>
                    <li>Подать жалобу в надзорный орган</li>
                </ul>
            </section>

            <section>
                <h3>8. Контакты</h3>
                <p>
                    По вопросам, связанным с обработкой персональных данных, обращайтесь:
                    <br />Email: <a href="mailto:info@spiria.ru">info@spiria.ru</a>
                    <br />Телефон: 8 (800) 123-45-67
                </p>
            </section>
        </div>
    );
}

// Content for Terms of Service
function TermsOfServiceContent() {
    return (
        <div className="legal-content">
            <h2>Условия использования</h2>
            <p className="legal-last-updated">Последнее обновление: {new Date().toLocaleDateString('ru-RU')}</p>
            
            <section>
                <h3>1. Принятие условий</h3>
                <p>
                    Используя платформу Spiria, вы соглашаетесь с настоящими Условиями использования. 
                    Если вы не согласны с этими условиями, пожалуйста, не используйте наш сервис.
                </p>
            </section>

            <section>
                <h3>2. Описание услуг</h3>
                <p>Spiria предоставляет следующие услуги:</p>
                <ul>
                    <li>Создание и прохождение медицинских опросов</li>
                    <li>Управление расписанием приёма лекарств</li>
                    <li>Связь между пациентами и медицинскими работниками</li>
                    <li>Хранение истории медицинских данных</li>
                    <li>Напоминания о предстоящих мероприятиях по здоровью</li>
                </ul>
            </section>

            <section>
                <h3>3. Регистрация и аккаунт</h3>
                <p>При регистрации вы обязуетесь:</p>
                <ul>
                    <li>Предоставить достоверную и актуальную информацию</li>
                    <li>Поддерживать актуальность данных в своём профиле</li>
                    <li>Не передавать доступ к аккаунту третьим лицам</li>
                    <li>Немедленно уведомить нас о несанкционированном доступе</li>
                </ul>
            </section>

            <section>
                <h3>4. Медицинская информация</h3>
                <p>
                    <strong>Важно:</strong> Spiria является вспомогательным инструментом и не заменяет 
                    очную консультацию с врачом. Все рекомендации, полученные через платформу, 
                    носят информационный характер.
                </p>
                <ul>
                    <li>В экстренных случаях немедленно обращайтесь в скорую помощь (103)</li>
                    <li>Не игнорируйте симптомы, требующие срочного вмешательства</li>
                    <li>Самолечение может быть опасным для здоровья</li>
                </ul>
            </section>

            <section>
                <h3>5. Запрещённое использование</h3>
                <p>Запрещается:</p>
                <ul>
                    <li>Использование сервиса для нелегальных целей</li>
                    <li>Попытки взлома или нарушения работы платформы</li>
                    <li>Распространение вредоносного ПО</li>
                    <li>Сбор данных других пользователей без согласия</li>
                    <li>Имперсонация медицинских работников</li>
                </ul>
            </section>

            <section>
                <h3>6. Интеллектуальная собственность</h3>
                <p>
                    Все материалы, размещённые на платформе (логотипы, тексты, дизайн, код), 
                    являются собственностью Spiria или её лицензиаров и защищены законодательством 
                    об интеллектуальной собственности.
                </p>
            </section>

            <section>
                <h3>7. Ограничение ответственности</h3>
                <p>
                    Spiria не несёт ответственности за:
                </p>
                <ul>
                    <li>Решения, принятые на основе информации из платформы</li>
                    <li>Технические сбои, не зависящие от нас</li>
                    <li>Убытки от использования или невозможности использования сервиса</li>
                    <li>Действия третьих лиц</li>
                </ul>
            </section>

            <section>
                <h3>8. Изменения условий</h3>
                <p>
                    Мы оставляем за собой право изменять настоящие Условия в любое время. 
                    Продолжение использования сервиса после изменений означает принятие новых условий.
                </p>
            </section>

            <section>
                <h3>9. Прекращение использования</h3>
                <p>
                    Мы можем приостановить или прекратить ваш доступ к сервису в случае 
                    нарушения настоящих Условий или по техническим причинам.
                </p>
            </section>

            <section>
                <h3>10. Контакты</h3>
                <p>
                    По вопросам, связанным с Условиями использования:
                    <br />Email: <a href="mailto:info@spiria.ru">info@spiria.ru</a>
                    <br />Телефон: 8 (800) 123-45-67
                </p>
            </section>
        </div>
    );
}

// Content for Cookie Policy
function CookiePolicyContent() {
    return (
        <div className="legal-content">
            <h2>Политика использования Cookie</h2>
            <p className="legal-last-updated">Последнее обновление: {new Date().toLocaleDateString('ru-RU')}</p>
            
            <section>
                <h3>1. Что такое cookie</h3>
                <p>
                    <strong>Cookie</strong> — это небольшие текстовые файлы, которые сохраняются на вашем устройстве 
                    (компьютере, планшете или смартфоне) при посещении веб-сайтов. Они позволяют сайту запоминать 
                    ваши действия и предпочтения на определённое время.
                </p>
            </section>

            <section>
                <h3>2. Какие cookie мы используем</h3>
                <p>На нашем сайте используются следующие типы cookie:</p>
                <ul>
                    <li>
                        <strong>Необходимые cookie</strong> — обеспечивают корректную работу сайта, 
                        позволяют вам авторизоваться и использовать основные функции платформы.
                    </li>
                    <li>
                        <strong>Функциональные cookie</strong> — запоминают ваши настройки и предпочтения 
                        (например, язык интерфейса, выбранные фильтры).
                    </li>
                    <li>
                        <strong>Аналитические cookie</strong> — помогают нам понять, как посетители 
                        взаимодействуют с сайтом, какие страницы посещают. Эти данные используются 
                        для улучшения работы платформы.
                    </li>
                    <li>
                        <strong>Сессионные cookie</strong> — временные файлы, которые удаляются после 
                        закрытия браузера. Используются для поддержания вашей сессии.
                    </li>
                    <li>
                        <strong>Постоянные cookie</strong> — хранятся на устройстве в течение определённого 
                        времени (например, для сохранения вашего согласия на использование cookie).
                    </li>
                </ul>
            </section>

            <section>
                <h3>3. Для чего мы используем cookie</h3>
                <ul>
                    <li>Обеспечение безопасности авторизации и работы с аккаунтом</li>
                    <li>Сохранение ваших настроек и предпочтений</li>
                    <li>Анализ посещаемости и поведения пользователей для улучшения сервиса</li>
                    <li>Поддержка функциональности сайта при навигации между страницами</li>
                    <li>Запоминание вашего согласия на обработку данных</li>
                </ul>
            </section>

            <section>
                <h3>4. Управление cookie</h3>
                <p>
                    Вы можете управлять использованием cookie через настройки вашего браузера:
                </p>
                <ul>
                    <li>Разрешить все cookie</li>
                    <li>Блокировать все cookie</li>
                    <li>Удалять cookie при закрытии браузера</li>
                    <li>Блокировать cookie от сторонних сайтов</li>
                </ul>
                <p>
                    <strong>Обратите внимание:</strong> отключение необходимых cookie может повлиять 
                    на работу сайта и ограничить доступ к некоторым функциям.
                </p>
            </section>

            <section>
                <h3>5. Срок хранения cookie</h3>
                <p>
                    Срок хранения cookie зависит от их типа:
                </p>
                <ul>
                    <li>Сессионные cookie — до закрытия браузера</li>
                    <li>Cookie согласия — 1 год</li>
                    <li>Аналитические cookie — до 2 лет</li>
                    <li>Функциональные cookie — до 1 года</li>
                </ul>
            </section>

            <section>
                <h3>6. Передача данных третьим лицам</h3>
                <p>
                    Мы не передаём данные из cookie третьим лицам для маркетинговых целей. 
                    Анонимные аналитические данные могут передаваться сервисам веб-аналитики 
                    (например, Яндекс.Метрика) для улучшения работы сайта.
                </p>
            </section>

            <section>
                <h3>7. Контакты</h3>
                <p>
                    По вопросам, связанным с использованием cookie, обращайтесь:
                    <br />Email: <a href="mailto:info@spiria.ru">info@spiria.ru</a>
                    <br />Телефон: 8 (800) 123-45-67
                </p>
            </section>
        </div>
    );
}

// Content for Company Presentation
function PresentationContent() {
    return (
        <div className="legal-content">
            <h2>О компании Spiria</h2>
            <p className="legal-last-updated">Цифровые решения для управления здоровьем</p>
            
            <section>
                <h3>Кто мы</h3>
                <p>
                    <strong>Spiria</strong> — современная цифровая платформа, созданная для упрощения 
                    взаимодействия между пациентами и медицинскими работниками. Мы объединяем передовые 
                    технологии и заботу о здоровье, делая медицинское обслуживание доступнее и эффективнее.
                </p>
            </section>

            <section>
                <h3>Наша миссия</h3>
                <p>
                    Сделать управление здоровьем простым, понятным и доступным для каждого. 
                    Мы верим, что технологии должны работать на благо людей, помогая им следить 
                    за своим здоровьем и поддерживать связь с врачами в любое время.
                </p>
            </section>

            <section>
                <h3>Что мы предлагаем</h3>
                <ul>
                    <li><strong>Медицинские опросы</strong> — удобный инструмент для сбора информации о состоянии здоровья</li>
                    <li><strong>Управление лекарствами</strong> — напоминания о приёме препаратов и учёт запасов</li>
                    <li><strong>Связь с врачами</strong> — прямой канал коммуникации с лечащими специалистами</li>
                    <li><strong>История болезни</strong> — безопасное хранение медицинских данных в одном месте</li>
                    <li><strong>Планировщик</strong> — удобное планирование приёмов и процедур</li>
                </ul>
            </section>

            <section>
                <h3>Наши преимущества</h3>
                <p>
                    <strong>🔒 Безопасность</strong> — все данные шифруются и хранятся на серверах в РФ
                </p>
                <p>
                    <strong>⚡ Удобство</strong> — доступ с любого устройства 24/7
                </p>
                <p>
                    <strong>🤝 Персонализация</strong> — индивидуальный подход к каждому пользователю
                </p>
                <p>
                    <strong>📱 Современность</strong> — актуальные технологии для вашего здоровья
                </p>
            </section>

            <section>
                <h3>Наши ценности</h3>
                <ul>
                    <li><strong>Забота о пациентах</strong> — их здоровье и комфорт на первом месте</li>
                    <li><strong>Прозрачность</strong> — честность во всём, что мы делаем</li>
                    <li><strong>Инновации</strong> — постоянное развитие и улучшение сервиса</li>
                    <li><strong>Доступность</strong> — качественная медицинская помощь для всех</li>
                </ul>
            </section>

            <section>
                <h3>География</h3>
                <p>
                    Штаб-квартира компании расположена в <strong>Уфе</strong>. 
                    Мы работаем с медицинскими учреждениями и частными практиками по всей России, 
                    помогая тысячам пациентов заботиться о своём здоровье каждый день.
                </p>
            </section>

            <section>
                <h3>Контакты</h3>
                <p>
                    Хотите узнать больше о сотрудничестве или задать вопрос?
                    <br />Email: <a href="mailto:info@spiria.ru">info@spiria.ru</a>
                    <br />Телефон: 8 (800) 123-45-67
                    <br />Адрес: Уфа
                </p>
            </section>
        </div>
    );
}

export default function LegalModal({ isOpen, onClose, type }) {
    // Lock body scroll when modal is open
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [isOpen]);

    // Close on escape key
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };
        
        if (isOpen) {
            document.addEventListener('keydown', handleEscape);
        }
        
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    const handleBackdropClick = (e) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    return (
        <div className="legal-modal-backdrop" onClick={handleBackdropClick}>
            <div className="legal-modal">
                <div className="legal-modal-header">
                    <button 
                        className="legal-modal-close" 
                        onClick={onClose}
                        aria-label="Закрыть"
                    >
                        <CloseIcon />
                    </button>
                </div>
                <div className="legal-modal-body">
                    {type === 'privacy' && <PrivacyPolicyContent />}
                    {type === 'terms' && <TermsOfServiceContent />}
                    {type === 'presentation' && <PresentationContent />}
                    {type === 'cookies' && <CookiePolicyContent />}
                </div>
                <div className="legal-modal-footer">
                    <button className="legal-modal-btn" onClick={onClose}>
                        Закрыть
                    </button>
                </div>
            </div>
        </div>
    );
}
